"use client";

import { TabPanel, TabProvider } from "@ariakit/react";
import { useState } from "react";

import styles from "./DiscoveryResult.module.scss";
import { DiscoverTabs } from "./DiscoverTabs";
import { ArticleSearchList } from "../Feed/DiscoverLayout/ArticleSearchList";
import { TopicsSearchList } from "../Feed/DiscoverLayout/TopicsSearchList";
import { Button } from "../Button/Button";
import { searchArticlesAndTopicsFromUrl } from "../../services/searchArticlesAndTopicsFromUrl";
import { DotLoader } from "../DotLoader/DotLoader";

export function DiscoveryResult({
  searchResult,
  searchQuery,
  url,
  empty,
}: {
  searchResult: any;
  searchQuery: string;
  url: string;
  empty?: boolean;
}) {
  const [prevSearchResult, setPrevSearchResult] = useState(searchResult);
  const [articles, setArticles] = useState(searchResult.data.articles);
  const [topics, setTopics] = useState(searchResult.data.topics);
  const [nextUrl, setNextUrl] = useState(url);
  const [loading, setLoading] = useState(false);
  const [isMoreTopics, setIsMoreTopics] = useState(!empty);
  const [isMoreArticles, setIsMoreArticles] = useState(!empty);

  // Reset state when searchResult changes (new search performed)
  if (prevSearchResult !== searchResult) {
    setPrevSearchResult(searchResult);
    setArticles(searchResult.data.articles);
    setTopics(searchResult.data.topics);
    setNextUrl(url);
    setIsMoreArticles(!empty);
    setIsMoreTopics(!empty);
  }

  const fetchMore = async () => {
    setLoading(true);
    const result = await searchArticlesAndTopicsFromUrl(nextUrl);
    if (result.error) {
      throw result.error;
    }
    setNextUrl(result.data.nextPage);
    if (result.data.articles.length) {
      setArticles([...articles, ...result.data.articles]);
    } else {
      setIsMoreArticles(false);
    }

    if (result.data.topics.length) {
      setTopics([...topics, ...result.data.topics]);
    } else {
      setIsMoreTopics(false);
    }
    setLoading(false);
  };

  return (
    <div className={styles.containerList}>
      <TabProvider defaultSelectedId="articles">
        <div className={styles.tabs}>
          <DiscoverTabs
            label="Typ av resultat"
            tabs={[
              {
                title: "Artiklar",
                id: "articles",
              },
              {
                title: "Ämnen",
                id: "topics",
              },
            ]}
          />
        </div>
        <TabPanel tabId="articles">
          <ArticleSearchList
            articles={articles}
            searchQuery={searchQuery || ""}
          />
          {isMoreArticles && !loading && (
            <div className={styles.loadMoreButtonContainer}>
              <Button
                onClick={fetchMore}
                size="small"
                variant="primary"
                text="Ladda fler artiklar"
              />
            </div>
          )}
        </TabPanel>
        <TabPanel tabId="topics">
          <div className={styles.topicsContainer}>
            <TopicsSearchList topics={topics} searchQuery={searchQuery || ""} />
          </div>
          {isMoreTopics && !loading && (
            <div className={styles.loadMoreButtonContainer}>
              <Button
                onClick={fetchMore}
                size="small"
                variant="primary"
                text="Ladda fler ämnen"
              />
            </div>
          )}
        </TabPanel>
      </TabProvider>
      {loading && <DotLoader />}
    </div>
  );
}
